import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CommunitiesComponent from '../../components/Communities';
import { getCommunitiesRequest } from '../../actionCreators/communitiesActions';
import { getUserOrganisationRequest } from '../../actionCreators/organisationActions';

const Communities = (props) => <CommunitiesComponent {...props} />;

const CommunitiesContainer = (props) => {
  const state = useSelector((state) => ({
    account: state.account,
    currentUser: state.currentUser,
    communities: state.communities.communitiesList,
    customAppId: state.customApp.id,
    organisation: state.organisation.currentOrganisation,
  }));

  const dispatch = useDispatch();

  const actions = {
    getCommunities: (payload) => dispatch(getCommunitiesRequest(payload)),
    getUserOrganisation: (payload) => dispatch(getUserOrganisationRequest(payload)),
  };

  return <Communities {...props} {...state} {...actions} />;
};

export default CommunitiesContainer;
